import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LOCAL_STORAGE_KEYS } from "newui/constants/localStorageKeys";

export interface AppMenuState {
	isCollapsed: boolean;
}

const initialState: AppMenuState = {
	isCollapsed: false,
};

export const appMenuSlice = createSlice({
	name: LOCAL_STORAGE_KEYS.APP_MENU_STATE,
	initialState,
	reducers: {
		setCollapsed: (state, action: PayloadAction<boolean>) => {
			state.isCollapsed = action.payload;
			try {
				localStorage.setItem(
					LOCAL_STORAGE_KEYS.APP_MENU_STATE,
					JSON.stringify({ isCollapsed: action.payload })
				);
			} catch (_e) {
				// ignore storage errors
			}
		},
		toggleCollapsed: (state) => {
			state.isCollapsed = !state.isCollapsed;
			try {
				localStorage.setItem(
					LOCAL_STORAGE_KEYS.APP_MENU_STATE,
					JSON.stringify({ isCollapsed: state.isCollapsed })
				);
			} catch (_e) {
				// ignore storage errors
			}
		},
	},
});

export const { setCollapsed, toggleCollapsed } = appMenuSlice.actions;

export default appMenuSlice.reducer;
